export function hexToRGB(hex, alpha) {
	const r = parseInt(hex.slice(1, 3), 16);
	const g = parseInt(hex.slice(3, 5), 16);
	const b = parseInt(hex.slice(5, 7), 16);

	if (alpha) {
		return `rgba(${r}, ${g} , ${b} ,${alpha})`;
	} else {
		return `rgb(${r},${g},${b})`;
	}
}

export function darkenColor(hex: string, percent: number) {
	if (!hex) return hex;
	let c = hex.replace('#', '');
	if (c.length === 3)
		c = c
			.split('')
			.map(x => x + x)
			.join('');
	const num = parseInt(c, 16);
	let r = (num >> 16) & 0xff;
	let g = (num >> 8) & 0xff;
	let b = num & 0xff;
	r = Math.max(0, Math.min(255, Math.floor(r * (1 - percent))));
	g = Math.max(0, Math.min(255, Math.floor(g * (1 - percent))));
	b = Math.max(0, Math.min(255, Math.floor(b * (1 - percent))));
	return `#${((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1)}`;
}
